module.exports = __webpack_public_path__ + "img/device.51aa90c6.svg";